import React from 'react';
import { filterValue } from './filterValue';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import './OutputLink.css';

const isAbsoluteLink = link => /http(s)?:\/\//.test(link);

export const OutputLink = (props, context) => {
  const value = filterValue(props);
  const absoluteLink = isAbsoluteLink(value)? value : ('http://'+value);

  return (
    <div className="OutputLink" style={props.style}>
      <div className="output-label">{getLabel(context.locale, props.label)}</div>
      <a href={absoluteLink} target="_blank">{value}</a>
    </div>
  );
};

OutputLink.contextTypes = {
  locale: PropTypes.string,
};

export default OutputLink;



// WEBPACK FOOTER //
// ./src/main/components/output/OutputLink.js